import * as app from './app';
import * as tel from './tel';
import * as customer from './customer';
import * as communicate from './communicate';
import * as system from './system';
import * as im from './im';
import * as knowledge from './knowledge';
import * as auth from './auth';
import * as user from './user';
import * as role from './role';
import * as report from './report';
import * as menu from './menu';
import * as messageCenter from './messageCenter';
import * as breathe from './breathe';
import * as project from './project';
import * as sms from './sms';
let api = {
	...app,
	...tel,
    ...customer,
	...communicate,
	...system,
	...im,
	...knowledge,
	...auth,
	...user,
	...role,
	...report,
	...menu,
	...messageCenter,
	...breathe,
	...project,
	...sms
};

Vue.prototype.$api = api;